/* eslint-disable */
/**
 * Vercel Blob URLs for the redesign building modals (bakery, hospital, hunting lodge, iron mine, sawmill,
 * stone mine/factory, support, water well, wheat farm). Wired into `VERCEL_BLOB_PRELOAD_PRIORITIZED` only —
 * not `assetWarmup` / `warmupAssets`.
 *
 * Inline assets shared with other screens (star, Coin, box, question_icon, water_reward_icon) stay in the
 * main preload list only to avoid duplicate entries in the manifest fingerprint input.
 */
const M = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Redesign/modal'

/** Deduplicated absolute URLs — warmed via `ensureVercelBlobPreload` → HTTP + SW cache. */
export const BUILDING_FACTORY_MODALS_BLOB_PRELOAD_URLS: readonly string[] = [
  `${M}/modal_background.webp`,
  `${M}/modal_hospital_bg.webp`,
  `${M}/modal_btn_close.webp`,
  `${M}/modal_btn_info.webp`,
  `${M}/modal_btn_n.webp`,
  `${M}/modal_btn_p.webp`,
  `${M}/modal_btn_upgrade.webp`,
  `${M}/modal_card_available_character.webp`,
  `${M}/modal_card_available_character1.webp`,
  `${M}/modal_card_character.webp`,
  `${M}/modal_card_character_locked.webp`,
  `${M}/modal_card_character_selected.webp`,
  `${M}/modal_card_detail.webp`,
  `${M}/modal_card_time_0.webp`,
  /**
   * `modal_card_character{1,_locked1,_selected1}` and `modal_card_time_{1,2,3,4}` are NOT listed:
   * all seven return HTTP 404 from the CDN — they were never uploaded. No component references
   * them either (every modal layout uses `modal_card_time_0`), so they were dead weight that cost
   * three failed retries each in the warm loop. Re-add if the artwork is ever published.
   */
  `${M}/modal_bakery_img.webp`,
  `${M}/modal_hospital_img.webp`,
  `${M}/modal_huntindlodge_img.webp`,
  `${M}/modal_iron_img.webp`,
  `${M}/modal_sawmill_img.webp`,
  `${M}/modal_stone_image.webp`,
  `${M}/modal_support_img.webp`,
  `${M}/modal_tower_img.webp`,
  `${M}/modal_training_img.webp`,
  `${M}/modal_waterwell_img.webp`,
  `${M}/modal_wheatfarm_img.webp`,
  `${M}/modal_levelbanner.webp`,
  `${M}/modal_ico_iron.webp`,
  `${M}/modal_ico_wheat.webp`,
  `${M}/modal_ico_bread.webp`,
  `${M}/modal_ico_wood.webp`,
  `${M}/modal_ico_stone.webp`,
  `${M}/modal_ico_clock.webp`,
  `${M}/modal_icon_water.webp`,
  // Training modal specific cards (spy/diplomacy tabs).
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/support/training-modal-tab-inactive-btn.webp',
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/support/spy-skill-bg.webp',
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/support/skill-search.webp',
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/support/skill-steal.webp',
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/support/skill-loyalty.webp',
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/support/skill-kill.webp',
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/buildings/live/boosting-tree.webp',
]
